<template>
  <div class="row justify-content-between f-width bg-white mt--20 mb--20">
    <div class="col-auto">
      <a class="float-left" href="https://clearbit.com">
        Logos provided by Clearbit
      </a>
    </div>
    <div class="col-auto text-right">
      {{ uiVersion }}
      <span v-for="group of recognisedReleases" :key="group.Hash">
        / {{ group.ReleaseName }}
      </span>
      <span class="pointer" style="color: blue" @click="navToReleases">
        (<span style="text-decoration: underline">Detail</span>)
      </span>
      <span
        v-for="group of unRecognisedReleases"
        :key="group.Hash"
        class="text-danger"
      >
        <br />
        <strong>
          This isn't a recognised release of the {{ group.Group }} software.
        </strong>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      releaseVersions: (state) => state.customers.releaseVersions,
    }),

    recognisedReleases() {
      if (this.releaseVersions && this.releaseVersions.Groups)
        return this.releaseVersions.Groups.filter((group) => !!group.ReleaseName);
      else return [];
    },

    unRecognisedReleases() {
      if (this.releaseVersions && this.releaseVersions.Groups)
        return this.releaseVersions.Groups.filter((group) => !group.ReleaseName);
      else return [];
    },

    uiVersion() {
      return require("../../package.json").version;
    },
  },

  methods: {
    navToReleases() {
      this.$router.push({ name: "releasesPage" });
    },
  },
};
</script>

